// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"198":"f824929c","790":"2c1af158"}[chunkId] + ".js";
};